import { Component, Input } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChronoInput } from '../../../shared/models/chrono.model';
import { CrActiviteInterne } from '../../../shared/models/activite-interne/activite-interne.model';
import { CrView } from '../../../shared/models/v2/cr.model';
import { PostCrRequest, PostCrResponse } from '../../../shared/models/v2/post-cr.model';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'cr-list-item',
  templateUrl: 'cr-list-item.component.html',
  standalone: true,
  styleUrls: ['./cr-list-item.component.scss'],
  imports: [NgIf, DatePipe, TranslateModule, IonicModule],
})
export class CrListItemComponent {
  @Input() cr: CrView | ChronoInput | CrActiviteInterne | PostCrRequest | PostCrResponse;

  constructor() {}

  getTitle(cr: CrView | ChronoInput | CrActiviteInterne | PostCrRequest | PostCrResponse): string {
    if (cr.type === 'cr-view' || cr.type === 'cr-response') {
      if (cr.ot.libelle_intervention) {
        return cr.ot.libelle_intervention;
      }
      if (cr.ot.description) {
        return cr.ot.description;
      }
    }
    if (cr.type === 'post-cr-request') {
      if (cr.ot.description) {
        return cr.ot.description;
      }
    }
    if (cr.type === 'cr-activite-interne') {
      const c = cr as CrActiviteInterne;
      if (c.cr_type_activite_realisee) {
        return c.cr_type_activite_realisee.toString();
      }
    }
    return '';
  }
}
